const r = /^https?:\/\//i;
function e(t) {
  return r.test(t);
}
function o(t = null, ...n) {
  return typeof t == "function" ? t(...n) : t;
}
function i(t) {
  return typeof t == "function" ? t() : t;
}
export {
  i as g,
  e as i,
  o as r
};
//# sourceMappingURL=index-lgh2EImO.mjs.map
